import { makeStyles } from '@mui/styles'
import { colors } from '../../../utils'


const useStyles = makeStyles({
    container: {
        height: 10
    },
    text: {
        '&.MuiTypography-root': {
            color: colors.palette.error,
            fontSize: '.8em',
            marginTop: 2,
            marginLeft: 5
        }
    }
})

export default useStyles